import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { init as initSentry } from '@sentry/angular';
import { App } from '~app/app';
import { ApplicationConfigFactory } from '~app/app.config';
import { AppConfig } from '~app/types/app-config';
import { environment } from './environments/environment';

fetch(environment.configPath)
  .then(res => res.json())
  .then((config: AppConfig) => {
    if (environment.production) {
      enableProdMode();
      initSentry({
        dsn: "https://3853d16cf26d490796c06c3b5c4b1ac5@o4506144349618176.ingest.us.sentry.io/4512091112931328",
        release: config.VERSION,
        environment: config.SENTRY_ENVIRONMENT,
      })
    }
    return bootstrapApplication(App, ApplicationConfigFactory(config));
  })
  .catch(err => console.error(err));
